import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmFilter } from "../../../Orchestrator/Types/Interface/IFmlmView";

class FmlmUpdateFilterAction extends BaseAction<void, IFmlmFilter> {
  override async run(): Promise<void> {
    const fmlmFilter = this.params;
    try {
      updateRecoilState("fmlmFilterAtom", fmlmFilter);
      updateRecoilState("isDepartureDateChangedAtom", false);
      if (typeof window !== "undefined" && fmlmFilter) {
        localStorage.setItem("fmlmFilterState", JSON.stringify(fmlmFilter));
      }
    } catch (e) {
    }
  }
}

export const fmlmUpdateFilterAction = new FmlmUpdateFilterAction();
